import { Loader } from "@nimble/react-requests/components/shared/loader";
import * as React from "react";

import { Button } from "@/components/ui/button";

export interface LoaderButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
}

const ButtonLoader = React.forwardRef<HTMLButtonElement, LoaderButtonProps>(
  ({ loading = false, children, disabled, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        disabled={disabled || loading}
        {...props}
        data-loading={loading}
      >
        {loading && <Loader />}
        {children}
      </Button>
    );
  },
);

ButtonLoader.displayName = "ButtonLoader";

export default ButtonLoader;
